export default "__VITE_ASSET__Bpsg2OKF__"